<template>
  <div v-loading="loading">
    <ClassVocabularyHomework
      v-if="exam && exam.type === 'vocabulary'"
      :examVaultId="exam._id"
      :initialExam="exam"
    />
    <ClassConversationHomework
      v-else-if="exam && exam.type === 'conversation'"
      :examVaultId="exam._id"
      :initialExam="exam"
    />
    <div v-else class="question-homework">
    <div
      class="md-layout-item md-small-size-100 md-xsmall-size-100"
      style="height: 60px"
      :style="$isMobileDevice ? 'margin-bottom: 40px' : ''"
    >
      <div
        class="md-layout w-100 header"
        style="color: #1cab36; margin: 0px 15px 10px 0px"
      >
        <div class="left-hw-btn">
          <md-button
            @click="goBack"
            class="md-icon-button"
            style="height: 58px; width: 58px; margin-right: 20px"
          >
            <md-icon
              style="
                font-size: 36px !important;
                color: #1cab36;
                line-height: 58px;
              "
              >arrow_back</md-icon
            >
          </md-button>

          <div v-if="exam && method !== 'create'" class="homework-title">
            {{ exam.title }}
          </div>
        </div>
        <div class="right-hw-btn">
          <md-button
            class="md-raised ai-button"
            @click.prevent="aiCreateDialog.visible = true"
            ><img
              src="@/assets/stars.png"
              style="height: 20px; padding-right: 10px"
            />
            Tạo với A.I
          </md-button>
        </div>
      </div>
    </div>

    <div v-if="exam">
      <div class="question-layout md-layout">
      <div
        class="md-layout-item md-size-20 md-small-size-100 question-group-list"
        :style="$isMobileDevice ? 'margin-bottom: 24px;' : ''"
      >
        <div
          class="question-header"
          style="
            color: #1cab36;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 14px;
            margin-top: 14px;
          "
        >
          {{ $t('QUESTION_GROUP') }}
        </div>
        <div class="question-groups">
          <div
            v-for="(qg, index) in questionGroups"
            :key="qg._id"
            class="q-item"
            :class="
              currentQuestionGroup && qg._id === currentQuestionGroup._id
                ? 'q-item-selected'
                : ''
            "
          >
            <span class="title" @click="handleSelectQuestionGroup(qg)"
              >{{ $t('QUESTION_GROUP') }} {{ index + 1 }}</span
            >
            <div class="settings">
              <span @click="handleUpdateQuestionGroup('update', qg)"
                ><md-icon>settings</md-icon></span
              >
              <span @click="handleDelete('questionGroup', qg)"
                ><md-icon>delete</md-icon></span
              >
            </div>
          </div>
        </div>
        <div class="add-question-group-btn">
          <span class="add-icon" @click="handleUpdateQuestionGroup('create')">
            <md-icon
              >add<md-tooltip md-direction="bottom">{{
                $t('CREATE')
              }}</md-tooltip></md-icon
            >
          </span>
        </div>
      </div>
      <div
        class="md-layout-item md-size-20 md-small-size-100 question-list"
        :style="$isMobileDevice ? 'margin-bottom: 24px;' : ''"
      >
        <div
          class="question-header"
          style="
            color: #1cab36;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 14px;
            margin-top: 14px;
          "
        >
          {{ $t('QUESTION') }}
        </div>
        <div class="questions">
          <div
            v-for="(q, index) in questions"
            :key="q._id"
            class="q-item"
            :class="
              currentQuestion && q._id === currentQuestion._id
                ? 'q-item-selected'
                : ''
            "
            @click="handleSelectQuestion(q)"
          >
            <span class="title">{{ $t('QUESTION') }} {{ index + 1 }}</span>
            <div class="settings">
              <span @click="handleUpdateQuestion('update', q)"
                ><md-icon>settings</md-icon></span
              >
              <span @click="handleDelete('question', q)"
                ><md-icon>delete</md-icon></span
              >
            </div>
          </div>
        </div>
        <div
          class="add-question-btn"
          @click="handleUpdateQuestion('create')"
          v-if="currentQuestionGroup"
        >
          <span class="add-icon"
            ><md-icon
              >add<md-tooltip md-direction="bottom">{{
                $t('CREATE')
              }}</md-tooltip></md-icon
            ></span
          >
        </div>
      </div>
      <div class="md-layout-item md-size-60 preview-section">
        <div
          class="question-header"
          style="
            color: #1cab36;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 14px;
            margin-top: 14px;
          "
        >
          {{ $t('QUESTION_CONTENT') }}
        </div>
        <div v-if="currentQuestionGroup" class="question-group-preview">
          <div class="title">{{ currentQuestionGroup.title }}</div>
          <div class="content" v-html="currentQuestionGroup.content" />
          <div class="md-layout">
            <div
              v-if="currentQuestionGroup.audioUrl"
              class="md-layout-item md-size-50 audio-preview"
            >
              <audio
                controls
                :src="currentQuestionGroup.audioUrl | googleDriveQuestionMedia"
              ></audio>
            </div>
            <div
              v-if="currentQuestionGroup.imgUrl"
              class="md-layout-item md-size-50"
            >
              <img
                :src="currentQuestionGroup.imgUrl | googleDriveQuestionMedia"
              />
            </div>
          </div>
        </div>
        <div v-if="currentQuestion" class="question-preview">
          <div class="title">
            {{ $t(questionTypeFilter(currentQuestion.type)) }}
          </div>
          <div class="content" v-html="currentQuestion.content" />
          <div class="md-layout">
            <div
              v-if="currentQuestion.audioUrl"
              class="md-layout-item md-size-50 audio-preview"
            >
              <audio
                controls
                :src="currentQuestion.audioUrl | googleDriveQuestionMedia"
              ></audio>
            </div>
            <div
              v-if="
                currentQuestion.imgUrl &&
                !['DaDImageLabeling'].includes(currentQuestion.type)
              "
              class="md-layout-item md-size-50"
            >
              <img :src="currentQuestion.imgUrl | googleDriveQuestionMedia" />
            </div>
          </div>

          <div class="answers-section">
            <QuestionAnswer
              :key="'preview-' | randomKey"
              :questionImageUrl="currentQuestion.imgUrl"
              :answers="currentQuestion.answers"
              :rightAnswer="currentQuestion.right"
              :questionType="currentQuestion.type"
              :fakeChoices="currentQuestion.fakeChoices"
              :preview="true"
            />
          </div>
        </div>
      </div>
    </div>
    </div>

    <md-dialog
      :md-active.sync="questionDialog.visible"
      :md-fullscreen="true"
      class="question-group-dialog"
    >
      <md-dialog-title>
        <div class="title">{{ $t('QUESTION') }}</div>
        <BaseButton :label="$t('SAVE')" @click="updateQuestion" />
      </md-dialog-title>

      <md-dialog-content v-loading="questionDialog.loading">
        <div class="input-field">
          <!-- <BaseInputQuestionTextArea
            label="Nội dung câu hỏi"
            :labelSize="16"
            v-model="temp.content"
          /> -->
          <div class="input-field">
            <BaseInputQuestionText
              placeholder="Thứ tự"
              label="Thứ tự"
              type="number"
              v-model="temp.index"
            />
          </div>
          <div
            class="title"
            style="font-weight: bold; font-size: 16px; padding-bottom: 10px"
          >
            Nội dung câu hỏi
          </div>
          <Tinymce
            v-model="temp.content"
            :menubar="''"
            :toolbar="[
              'bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote pastetext undo redo removeformat',
              'hr bullist numlist preview table forecolor backcolor fullscreen fontsizeselect'
            ]"
            :height="300"
          />
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <BaseInputQuestionFile
              label="Hình ảnh"
              accept="image/*"
              :labelSize="16"
              :loading.sync="uploadLoading.imgUrl"
              v-model="temp.imgUrl"
              iconClass="image"
              :storageClass="config.storageClass"
              :file="file.imgUrl"
              @file-selected="
                (val) => {
                  handleUpload('imgUrl', val)
                }
              "
              @clear="clearFile('imgUrl')"
            />
          </div>
          <div class="md-layout-item">
            <BaseInputQuestionFile
              label="Âm thanh"
              :labelSize="16"
              accept=".mp3,.wav,.m4a,.flac"
              :loading.sync="uploadLoading.audioUrl"
              v-model="temp.audioUrl"
              iconClass="audio"
              :storageClass="config.storageClass"
              :file="file.audioUrl"
              @file-selected="
                (val) => {
                  handleUpload('audioUrl', val)
                }
              "
              @clear="clearFile('audioUrl')"
            />
          </div>
        </div>

        <div class="input-field">
          <BaseInputQuestionSelect
            label="Dạng câu hỏi"
            :labelSize="16"
            v-model="temp.type"
            :options="[
              {
                _id: 'MultiChoice',
                name: 'Trắc nghiệm'
              },
              {
                _id: 'MultiSelect',
                name: 'Trắc nghiệm (Nhiều đáp án)'
              },
              {
                _id: 'Dropdown',
                name: 'Chọn đáp án'
              },
              {
                _id: 'ShortAnswer',
                name: 'Điền đáp án đúng'
              },
              {
                _id: 'StringSorting',
                name: 'Sắp xếp chữ cái, từ'
              },
              {
                _id: 'Classification',
                name: 'Phân loại'
              },
              {
                _id: 'Speaking',
                name: 'Phát âm'
              },
              {
                _id: 'UnderlineWord',
                name: 'Gạch chân'
              },
              {
                _id: 'Matching',
                name: 'Nối đáp án đúng'
              },
              {
                _id: 'Duo',
                name: 'Nối cặp'
              },
              {
                _id: 'MultiMatching',
                name: 'Ghép nối (nhiều lần)'
              },
              {
                _id: 'WordSearch',
                name: 'Tìm ô chữ'
              },
              {
                _id: 'CompleteSentence',
                name: 'Hoàn thành câu'
              },
              {
                _id: 'DaDImageLabeling',
                name: 'Kéo thả nhãn vào hình ảnh'
              },
              {
                _id: 'FillInTheBlanks',
                name: 'Điền từ vào chỗ trống'
              },
              {
                _id: 'Hanzi',
                name: 'Tập viết chữ Hán'
              }
            ]"
            :multiple="false"
          />
        </div>

        <div class="input-field">
          <div class="title" style="font-weight: bold; font-size: 16px">
            Câu trả lời
          </div>
          <QuestionAnswer
            :key="temp._id || '-edit-' + randomKey()"
            :questionImageUrl="temp.imgUrl"
            :answers="temp.answers"
            :rightAnswer="temp.right"
            :questionType="temp.type"
            :fakeChoices="temp.fakeChoices"
            :preview="false"
            :examVaultId="exam._id"
            @updateAnswer="handleUpdateAnswer"
            @updateRightAnswer="handleUpdateRightAnswer"
            @updateFakeChoiceToParent="handleUpdateFakeChoiceToParent"
          />
        </div>

        <div class="input-field">
          <div class="title" style="font-weight: bold; font-size: 16px">
            Lời giải
          </div>
          <Tinymce v-model="temp.answerHint" :height="300" />
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      :md-active.sync="questionGroupDialog.visible"
      class="question-group-dialog"
    >
      <md-dialog-title>
        <div class="title">{{ $t('QUESTION_GROUP') }}</div>
        <BaseButton :label="$t('SAVE')" @click="updateQuestionGroup" />
      </md-dialog-title>
      <md-dialog-content v-loading="questionGroupDialog.loading">
        <div class="input-field">
          <BaseInputQuestionText
            placeholder="Tiêu đề nhóm câu hỏi"
            label="Tiêu đề nhóm câu hỏi"
            v-model="temp.title"
          />
        </div>
        <div class="input-field">
          <BaseInputQuestionText
            placeholder="Thứ tự"
            label="Thứ tự"
            type="number"
            v-model="temp.index"
          />
        </div>
        <div class="input-field">
          <!-- <BaseInputQuestionTextArea
            label="Nội dung nhóm câu hỏi"
            v-model="temp.content"
          /> -->
          <div class="title" style="font-weight: bold; font-size: 16px">
            Nội dung nhóm câu hỏi
          </div>
          <Tinymce
            v-model="temp.content"
            :menubar="''"
            :toolbar="[
              'bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote pastetext undo redo removeformat',
              'hr bullist numlist preview table forecolor backcolor fullscreen fontsizeselect'
            ]"
            :height="300"
          />
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <BaseInputQuestionFile
              label="Hình ảnh"
              accept="image/*"
              :loading.sync="uploadLoading.imgUrl"
              v-model="temp.imgUrl"
              iconClass="image"
              :storageClass="config.storageClass"
              :file="file.imgUrl"
              @file-selected="
                (val) => {
                  handleUpload('imgUrl', val)
                }
              "
              @clear="clearFile('imgUrl')"
            />
          </div>
          <div class="md-layout-item">
            <BaseInputQuestionFile
              label="Âm thanh"
              accept="audio/*"
              :loading.sync="uploadLoading.audioUrl"
              v-model="temp.audioUrl"
              iconClass="audio"
              :storageClass="config.storageClass"
              :file="file.audioUrl"
              @file-selected="
                (val) => {
                  handleUpload('audioUrl', val)
                }
              "
              @clear="clearFile('audioUrl')"
            />
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>

    <BaseConfirmDialog
      :active.sync="deleteDialog.active"
      :title="deleteDialog.title"
      :content="deleteDialog.content"
      :loading="deleteDialog.loading"
      @close="handleCloseDeleteDialog"
      @cancel="handleCloseDeleteDialog"
      @confirm="deleteDialog.actionMethod(deleteDialog.data)"
    />

    <el-dialog
      :visible.sync="aiCreateDialog.visible"
      width="840px"
      :append-to-body="true"
      custom-class="ai-create-dialog"
    >
      <div class="dialog-title">
        <img src="@/assets/stars.png" />
        <span>Tạo bài tập với A.I</span>
      </div>
      <div v-if="aiCreateDialog.step === 1" class="ai-step-1">
        <div class="upload-area">
          <i class="el-icon-upload"></i>
          <p>Tải file/hình ảnh đề hoặc bài tập lên</p>
          <el-button type="success" @click="openFileDialog"
            >Tải lên từ thiết bị của bạn</el-button
          >
          <p>Định dạng file chấp nhận được: PDF, JPG, PNG, DOCX</p>
          <p>Giới hạn kích thước: 10MB</p>
          <!-- Thay đổi từ 25MB thành 10MB -->
        </div>
        <input
          type="file"
          ref="fileInput"
          @change="handleFileUpload"
          style="display: none"
          accept=".pdf,.jpg,.png,.docx"
        />
      </div>
      <div v-else-if="aiCreateDialog.step === 2" class="ai-step-2">
        <!-- File upload section -->
        <div class="file-upload-section">
          <div class="uploaded-file" v-if="aiCreateDialog.uploadedFile">
            <span
              ><i
                class="el-icon-document"
                style="width: 36px; padding-right: 10px"
              ></i
              >{{ aiCreateDialog.uploadedFile.name }}</span
            >
            <el-button @click="removeUploadedFile"
              ><i
                class="el-icon-delete"
                style="width: 24px; padding-right: 10px"
              ></i
              >Hủy</el-button
            >
          </div>
        </div>

        <div class="question-area">
          <!-- Question type selection -->
          <div class="question-config">
            <p>Thêm lời giải cho từng câu hỏi</p>
            <el-switch v-model="aiCreateDialog.addExplanation"></el-switch>
          </div>

          <div class="question-types">
            <p>Dạng câu hỏi</p>
            <div class="type-buttons">
              <el-button
                :class="
                  aiCreateDialog.selectedTypes.includes('Auto')
                    ? 'success'
                    : 'default'
                "
                @click="
                  aiCreateDialog.selectedTypes.includes('Auto')
                    ? null
                    : toggleQuestionType('Auto', true)
                "
              >
                Tự động
              </el-button>
              <el-button
                v-for="type in questionTypes"
                :key="type._id"
                :class="
                  aiCreateDialog.selectedTypes.includes(type._id)
                    ? 'success'
                    : 'default'
                "
                @click="toggleQuestionType(type._id)"
              >
                {{ type.name }}
              </el-button>
            </div>
          </div>
        </div>

        <el-button type="success" @click="proceedToUpload"
          >Tạo bài tập với A.I</el-button
        >
      </div>

      <div v-else-if="aiCreateDialog.step === 3" class="ai-step-3">
        <div class="loading-section">
          <div class="spinner"></div>
          <p>Vui lòng đợi trong lúc A.I đang tạo bài tập cho bạn</p>
        </div>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import examVaultApi from '@/api/exam-vault'
import { validUrl } from '@/utils/validate'
import QuestionAnswer from './components/QuestionAnswer.vue'
import { questionTypeFilter } from '@/filters/index'
import { createQuestionExamVaultWithAI } from '@/api/content-flow'
import Tinymce from '@/components/Tinymce'
import ClassVocabularyHomework from '@/views/ClassVocabularyHomework.vue'
import ClassConversationHomework from '@/views/ClassConversationHomework.vue'

export default {
  components: {
    QuestionAnswer,
    Tinymce,
    ClassVocabularyHomework,
    ClassConversationHomework
  },
  data() {
    return {
      questionTypeFilter,
      exam: {},
      loading: false,
      homeworkLoading: false,
      method: 'create',
      questionGroupDialog: {
        visible: false,
        method: '',
        loading: false
      },
      aiCreateDialog: {
        visible: false,
        method: '',
        loading: false,
        step: 1,
        uploadedFile: null,
        addExplanation: true,
        selectedTypes: ['Auto']
      },
      isCloneQuestion: false,
      questionTypes: [
        {
          _id: 'MultiChoice',
          name: 'Trắc nghiệm'
        },
        {
          _id: 'MultiSelect',
          name: 'Trắc nghiệm (Nhiều đáp án)'
        },
        {
          _id: 'Dropdown',
          name: 'Chọn đáp án'
        },
        {
          _id: 'ShortAnswer',
          name: 'Điền đáp án đúng'
        },
        {
          _id: 'StringSorting',
          name: 'Sắp xếp chữ cái, từ'
        },
        {
          _id: 'Classification',
          name: 'Phân loại'
        },
        {
          _id: 'Speaking',
          name: 'Phát âm'
        },
        {
          _id: 'UnderlineWord',
          name: 'Gạch chân'
        },
        {
          _id: 'Matching',
          name: 'Nối đáp án đúng'
        },
              {
                _id: 'Duo',
                name: 'Nối cặp'
              },
              {
                _id: 'MultiMatching',
                name: 'Ghép nối (nhiều lần)'
              },
        {
          _id: 'WordSearch',
          name: 'Tìm ô chữ'
        },
        {
          _id: 'DaDImageLabeling',
          name: 'Kéo thả nhãn vào hình ảnh'
        },
        {
          _id: 'FillInTheBlanks',
          name: 'Điền từ vào chỗ trống'
        },
        {
          _id: 'Hanzi',
          name: 'Tập viết chữ Hán'
        }
      ],
      questionDialog: {
        visible: false,
        method: '',
        loading: false
      },
      temp: {},
      file: {
        imgUrl: '',
        audioUrl: ''
      },
      uploadLoading: {
        imgUrl: false,
        audioUrl: false
      },
      currentQuestionGroup: null,
      currentQuestion: null,
      deleteDialog: {
        active: false,
        title: '',
        content: '',
        loading: false,
        data: null
      },
      questionGroups: [],
      questions: []
    }
  },
  computed: {
    ...mapGetters({
      config: 'config'
    })
  },
  watch: {
    $route: {
      handler: async function () {
        this.loading = true

        if (this.$route?.params?.examVaultId) {
          this.exam = await this.$store.dispatch(
            'exam-vault/fetchExamById',
            this.$route.params.examVaultId
          )

          if (!this.exam) {
            return
          }

          this.$nextTick(() => {
            this.$set(this, 'homeworkTemp', _.cloneDeep(this.exam))
          })

          const questionGroups = await this.$store.dispatch(
            'question/GetEVQuestionGroups',
            {
              query: {
                examVaultId: this.exam._id
              }
            }
          )

          this.commitSetQuestionGroups(questionGroups)
          this.commitSetQuestions([])

          this.method = 'update'
        }

        this.loading = false
      },
      immediate: true,
      deep: true
    },
    'temp.type': {
      handler(val, oldVal) {
        if (this.isCloneQuestion) {
          this.isCloneQuestion = false
          return
        }
        switch (val) {
          case 'MultipleChoice':
            this.temp.answers = []
            delete this.temp.right
            break
          case 'ShortAnswer':
            this.temp.right = []
            delete this.temp.answers
            break
          case 'StringSorting':
            this.temp.right = ''
            delete this.temp.answers
            break
          case 'Speaking':
            this.temp.right = ''
            delete this.temp.answers
            break
          case 'Classification':
            this.temp.right = []
            this.temp.answers = {
              list: [],
              classificationFields: []
            }
            break
          case 'UnderlineWord':
            this.temp.right = []
            this.temp.answers = {
              type: '',
              phrase: ''
            }
            break
          case 'Matching':
          case 'Duo':
            this.temp.right = []
            this.temp.answers = {
              list: [],
              classificationFields: []
            }
            break
          case 'WordSearch':
            this.temp.right = []
            this.temp.answers = {
              w: 0,
              h: 0,
              crossword: []
            }
            break
          case 'CompleteSentence':
            this.temp.right = []
            this.temp.answers = {
              phrase: ''
            }
            this.temp.fakeChoices = {}
            break
          case 'DaDImageLabeling':
            this.temp.right = []
            break
          case 'FillInTheBlanks':
            this.temp.right = []
            this.temp.answers = ''
            break
        }
      },
      immediate: true
    }
  },
  methods: {
    randomKey(prefix) {
      return (
        `${prefix}-` + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      )
    },

    commitSetQuestionGroups(data) {
      this.questionGroups = data
    },

    commitCreateQuestionGroup(data) {
      this.questionGroups.push(data)
    },

    commitUpdateQuestionGroup(data) {
      const index = _.findIndex(this.questionGroups, (qg) => {
        return qg._id.toString() === data._id.toString()
      })

      if (index !== -1) {
        this.questionGroups.splice(index, 1, data)
      }
    },

    commitDeleteQuestionGroup(data) {
      const index = _.findIndex(this.questionGroups, (qg) => {
        return qg._id.toString() === data._id.toString()
      })

      if (index !== -1) {
        this.questionGroups.splice(index, 1)
      }
    },

    commitSetQuestions(data) {
      this.questions = data
    },

    commitCreateQuestion(data) {
      this.questions.push(data)
    },

    commitUpdateQuestion(data) {
      const index = _.findIndex(this.questions, (q) => {
        return q._id.toString() === data._id.toString()
      })

      if (index !== -1) {
        this.questions.splice(index, 1, data)
      }
    },

    commitDeleteQuestion(data) {
      const index = _.findIndex(this.questions, (q) => {
        return q._id.toString() === data._id.toString()
      })

      if (index !== -1) {
        this.questions.splice(index, 1)
      }
    },

    handleUpdateAnswer(type, answers) {
      this.$set(this.temp, 'answers', answers)
    },

    handleUpdateFakeChoiceToParent(type, fakeChoices) {
      this.$set(this.temp, 'fakeChoices', fakeChoices)
    },

    handleUpdateRightAnswer(type, right) {
      this.$set(this.temp, 'right', right)
    },

    async handleSelectQuestionGroup(item) {
      this.commitSetQuestions([])
      this.$set(this, 'currentQuestionGroup', _.cloneDeep(item))
      this.$set(this, 'currentQuestion', null)
      const questions = await this.$store.dispatch('question/GetEVQuestions', {
        params: {
          questionGroupId: item._id
        }
      })
      this.commitSetQuestions(questions)
      if (questions.length > 0) {
        this.handleSelectQuestion(questions[0])
      }
    },

    async handleSelectQuestion(item) {
      this.$set(this, 'currentQuestion', _.cloneDeep(item))
    },

    async updateQuestionGroup() {
      try {
        this.questionGroupDialog.loading = true
        if (this.questionGroupDialog.method === 'create') {
          const questionGroup = await this.$store.dispatch(
            'question/CreateEVQuestionGroup',
            {
              query: {
                examVaultId: this.temp.examVaultId
              },
              body: this.temp,
              params: {}
            }
          )

          this.commitCreateQuestionGroup(questionGroup)
          this.handleSelectQuestionGroup(questionGroup)
        } else {
          const questionGroup = await this.$store.dispatch(
            'question/UpdateEVQuestionGroup',
            {
              query: {},
              body: this.temp,
              params: {
                questionGroupId: this.temp._id
              }
            }
          )

          this.commitUpdateQuestionGroup(questionGroup)
          this.handleSelectQuestionGroup(questionGroup)
        }

        this.questionGroupDialog.loading = false
        this.questionGroupDialog.visible = false

        this.$notify({
          type: 'success',
          title: this.$t('M_TITLE_SUCCESS'),
          message: `${
            this.questionGroupDialog.method === 'create' ? 'Thêm' : 'Cập nhật'
          } nhóm câu hỏi thành công`
        })
      } catch (error) {
        this.questionGroupDialog.loading = false
      }
    },

    validMatchingQuestion(answers) {
      let ok = true
      if (
        answers &&
        answers.classificationFields &&
        answers.classificationFields.length > 0
      ) {
        answers.classificationFields.forEach((item) => {
          if (!validUrl(item)) {
            ok = false
          }
        })
      }

      return ok
    },

    async updateQuestion() {
      try {
        this.questionDialog.loading = true
        if (this.questionDialog.method === 'create') {
          const question = await this.$store.dispatch(
            'question/CreateEVQuestion',
            {
              query: {
                examVaultId: this.exam._id
              },
              body: this.temp,
              params: {
                questionGroupId: this.currentQuestionGroup._id
              }
            }
          )

          this.commitCreateQuestion(question)
          this.currentQuestion = question
        } else {
          const question = await this.$store.dispatch(
            'question/UpdateEVQuestion',
            {
              query: {
                examVaultId: this.exam._id
              },
              body: this.temp,
              params: {
                questionGroupId: this.currentQuestionGroup._id,
                questionId: this.temp._id
              }
            }
          )

          this.commitUpdateQuestion(question)
          this.currentQuestion = question
        }

        this.questionDialog.loading = false
        this.questionDialog.visible = false
        this.$notify({
          type: 'success',
          title: this.$t('M_TITLE_SUCCESS'),
          message: `${
            this.questionDialog.method === 'create' ? 'Thêm' : 'Cập nhật'
          } câu hỏi thành công`
        })
      } catch (error) {
        this.questionDialog.loading = false
      }
    },

    handleDelete(type, item) {
      if (type === 'questionGroup') {
        Object.assign(this.deleteDialog, {
          active: true,
          title: 'Xoá nhóm câu hỏi',
          content: `Bạn có muốn xoá nhóm câu hỏi: ${item.title} không?`,
          data: item,
          actionMethod: this.deleteQuestionGroup
        })
      }

      if (type === 'question') {
        Object.assign(this.deleteDialog, {
          active: true,
          title: 'Xoá câu hỏi',
          content: `Bạn có muốn xoá câu hỏi này không?`,
          data: item,
          actionMethod: this.deleteQuestion
        })
      }
    },

    handleCloseDeleteDialog() {
      Object.assign(this.deleteDialog, {
        loading: false,
        active: false
      })
    },

    async deleteQuestionGroup(questionGroup) {
      await this.$store.dispatch('question/DeleteEVQuestionGroup', {
        query: {
          examVaultId: this.exam._id
        },
        params: {
          questionGroupId: questionGroup._id
        }
      })

      this.commitDeleteQuestionGroup(questionGroup)

      this.$notify({
        type: 'success',
        title: this.$t('M_TITLE_SUCCESS'),
        message: 'Xoá nhóm câu hỏi thành công'
      })

      this.handleCloseDeleteDialog()
    },

    async deleteQuestion(question) {
      await this.$store.dispatch('question/DeleteEVQuestion', {
        query: {
          examVaultId: this.exam._id
        },
        params: {
          questionGroupId: this.currentQuestionGroup._id,
          questionId: question._id
        }
      })

      this.commitDeleteQuestion(question)

      this.$notify({
        type: 'success',
        title: this.$t('M_TITEV_SUCCESS'),
        message: 'Xoá câu hỏi thành công'
      })

      this.handleCloseDeleteDialog()
    },

    handleUpdateQuestion(method, question) {
      if (!this.currentQuestionGroup) {
        this.$notify({
          type: 'error',
          title: 'Lỗi',
          message: 'Vui lòng chọn nhóm câu hỏi'
        })
        return
      }

      if (question) {
        this.isCloneQuestion = true
        this.temp = _.cloneDeep(question)
        this.file = {
          imgUrl: question.imgUrl,
          audioUrl: question.audioUrl
        }
      } else {
        this.temp = {
          questionGroupId: this.currentQuestionGroup._id
        }
        this.file = {
          imgUrl: '',
          audioUrl: ''
        }
      }

      Object.assign(this.questionDialog, {
        visible: true,
        method: method,
        loading: false
      })
    },

    handleUpdateQuestionGroup(method, questionGroup) {
      if (questionGroup) {
        this.temp = _.cloneDeep(questionGroup)
        this.file = {
          imgUrl: questionGroup.imgUrl,
          audioUrl: questionGroup.audioUrl
        }
      } else {
        this.temp = {
          examVaultId: this.exam._id
        }
        this.file = {
          imgUrl: '',
          audioUrl: ''
        }
      }

      Object.assign(this.questionGroupDialog, {
        visible: true,
        method: method,
        loading: false
      })
    },

    async handleUpload(key, files) {
      if (this.config.storageClass === 1) {
        await this.$store.dispatch('media/GetSharedLink', {
          fileId: files.id,
          accessToken: this.googleDrive.accessToken
        })
        this.$set(this.temp, key, files.id)
        this.$set(this.file, key, files)
        return
      }

      if (files.length > 0) {
        await this.uploadAttachment(files[0], key)
      }
    },

    async uploadAttachment(file, key) {
      if (this.uploadLoading[key]) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng đợi tải lên các tập tin trước đó hoàn tất.'
        })

        return
      }

      if (!this.exam) {
        this.$notify({
          type: 'warning',
          title: 'Vui lòng thử lại sau giây lát'
        })
        return
      }

      this.$set(this.uploadLoading, key, true)
      try {
        const response = await examVaultApi.uploadAttachment({
          file,
          examVaultId: this.exam._id
        })

        this.$set(this.temp, key, '/' + response.data.key)

        this.$set(this.file, key, this.getFileName(response.data.key))
      } catch (error) {
        console.log(error)
      }
      this.$set(this.uploadLoading, key, false)
    },

    clearFile(key) {
      this.$set(this.file, key, null)
      this.$set(this.temp, key, null)
      this.hasVideoChanges = true
    },

    getFileName(url) {
      if (!url) {
        return ''
      }

      let paths = url.split('/')
      paths = paths[paths.length - 1].split('?')[0]
      return paths
    },

    goBack() {
      this.$router.push({
        name: 'ExamVault',
        params: {},
        query: this.$route.query
      })
    },

    openFileDialog() {
      this.$refs.fileInput.click()
    },

    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        // Kiểm tra kích thước file (10MB = 10 * 1024 * 1024 bytes)
        const maxSize = 10 * 1024 * 1024 // 10MB

        if (file.size > maxSize) {
          this.$notify({
            type: 'error',
            title: 'Lỗi',
            message:
              'Kích thước file vượt quá giới hạn 10MB. Vui lòng chọn file nhỏ hơn.'
          })

          // Reset input file
          event.target.value = ''
          return
        }

        this.aiCreateDialog.uploadedFile = file
        this.aiCreateDialog.step = 2
      }
    },

    removeUploadedFile() {
      this.aiCreateDialog.uploadedFile = null
      this.aiCreateDialog.step = 1
    },

    toggleQuestionType(type, clear) {
      if (clear) {
        this.aiCreateDialog.selectedTypes = []
        this.aiCreateDialog.selectedTypes.push(type)
      } else {
        if (this.aiCreateDialog.selectedTypes.includes('Auto')) {
          this.aiCreateDialog.selectedTypes = []
        }
        const index = this.aiCreateDialog.selectedTypes.indexOf(type)
        if (index > -1) {
          this.aiCreateDialog.selectedTypes.splice(index, 1)
          if (this.aiCreateDialog.selectedTypes.length === 0) {
            this.aiCreateDialog.selectedTypes.push('Auto')
          }
        } else {
          this.aiCreateDialog.selectedTypes.push(type)
        }
      }
    },

    async proceedToUpload() {
      try {
        this.aiCreateDialog.step = 3 // Loading step

        const requestData = {
          file: this.aiCreateDialog.uploadedFile,
          idHomework: this.exam._id,
          hasAnswerHint: this.aiCreateDialog.addExplanation
        }

        if (this.aiCreateDialog.selectedTypes.length > 0) {
          requestData.questionTypes = this.aiCreateDialog.selectedTypes
        }

        // Gửi request tạo câu hỏi với AI
        const response = await createQuestionExamVaultWithAI(
          requestData,
          (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            console.log(`Upload progress: ${percentCompleted}%`)
          }
        )

        // Kiểm tra response message
        if (response.data && response.data.message === 'Workflow was started') {
          // Hệ thống đã tiếp nhận yêu cầu
          this.handleAIWorkflowStarted()
        } else {
          // Handle other responses if needed
          this.handleAIError('Phản hồi không mong đợi từ server')
        }
      } catch (error) {
        console.error('AI Generation failed:', error)
        this.handleAIError(
          error.response?.data?.message ||
            'Có lỗi xảy ra khi tạo bài tập với A.I'
        )
      }
    },

    handleAIWorkflowStarted() {
      // Đóng dialog
      this.aiCreateDialog.visible = false
      this.aiCreateDialog.step = 1
      this.resetAIDialog()

      // Hiển thị thông báo yêu cầu chờ
      this.$notify({
        type: 'success',
        title: 'Yêu cầu đã được tiếp nhận',
        message:
          'Hệ thống đang xử lý yêu cầu tạo bài tập với A.I. Vui lòng chờ vài phút và kiểm tra lại.',
        duration: 8000 // Hiển thị lâu hơn (8 giây)
      })
    },

    handleAIError(error) {
      // QUAY VỀ STEP 2 ĐỂ USER CÓ THỂ THỬ LẠI
      this.aiCreateDialog.step = 2

      // HIỂN THỊ THÔNG BÁO LỖI
      this.$notify({
        type: 'error',
        title: 'Lỗi',
        message: error || 'Có lỗi xảy ra khi tạo bài tập với A.I'
      })
    },

    resetAIDialog() {
      this.aiCreateDialog.uploadedFile = null
      this.aiCreateDialog.selectedTypes = []
      this.aiCreateDialog.addExplanation = true
    }
  },
  created() {}
}
</script>

<style lang="scss">
.question-homework {
  height: 100%;
  background: #fff;

  .header {
    padding: 6px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;

    .right-hw-btn,
    .left-hw-btn {
      float: right;
      display: flex;
      align-items: center;
    }

    .right-hw-btn {
      padding-right: 32px;
      .ai-button {
        text-transform: unset;
        padding: 10px 0;
        border: 1px solid #1cab36;
        border-radius: 5px;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        leading-trim: both;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .homework-edit {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 6px;
        color: #333;
        border-radius: 5px;
      }
      .homework-edit:hover {
        background: #1cab36 !important;
        color: #fff !important;
        .md-icon {
          color: #fff !important;
        }
      }
      .md-icon {
        font-size: 14px !important;
      }
      .label {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .homework-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;
    padding-right: 12px;
    cursor: pointer;
  }

  .question-group-list,
  .question-list,
  .preview-section {
    height: calc(100vh - 60px);
  }

  .question-group-list,
  .question-list {
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    position: relative;

    .questions,
    .question-groups {
      height: calc(100vh - 60px - 85px - 20px);
      overflow-y: auto;

      .q-item {
        width: 100%;
        font-size: 14px;
        font-weight: normal;
        height: 50px;
        padding: 4px 8px;
        display: flex;
        cursor: pointer;

        .title {
          width: calc(100% - 80px);
          display: flex;
          align-items: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .settings {
          padding-left: 10px;
          width: 70px;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          .md-icon {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
            cursor: pointer;
          }
        }
      }

      .q-item:hover {
        background: #e6fbea;
      }

      .q-item-selected {
        background: #e6fbea !important;
        font-weight: bold;
      }
    }

    .add-question-group-btn,
    .add-question-btn {
      height: 60px;
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      background-color: #fff;

      .add-icon {
        background: #1cab36;
        border-radius: 50%;
        padding: 5px;
        margin-right: 20px;

        .md-icon {
          color: #fff;
        }
      }

      color: #1cab36;
      font-weight: bold;
      font-size: 16px;
    }
  }

  .preview-section {
    overflow-y: auto;
    padding: 0 24px;
    .question-preview,
    .question-group-preview {
      padding: 12px;
      text-align: left;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #1cab36;
      }
      .content {
        padding-top: 12px;
        padding-bottom: 24px;
      }

      .audio-preview {
        display: flex;
        justify-content: center;
        align-items: center;

        audio {
          width: 100%;
          height: 50px;
        }
      }
    }
  }
}

.question-group-dialog {
  .md-dialog-container {
    max-width: 60%;
  }
  .md-dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin: 12px 24px 24px;
    padding: 0;
  }
}
.el-dialog.ai-create-dialog {
  padding: 40px;
  text-align: center;

  .el-dialog__header {
    display: none; // Ẩn header mặc định
  }

  .el-dialog__body {
    .dialog-title {
      text-align: center;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      i {
        font-size: 20px;
        color: #1cab36;
      }

      span {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }

    .ai-step-1 {
      .upload-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px;
        border: 2px dashed #dcdfe6;
        border-radius: 8px;
        background-color: #fafafa;
        text-align: center;

        .el-icon-upload {
          font-size: 48px;
          color: #c0c4cc;
          margin-bottom: 16px;
        }

        p {
          margin: 8px 0;
          color: #666;

          &:first-of-type {
            font-size: 16px;
            font-weight: 500;
            color: #333;
          }

          &:last-of-type {
            font-size: 12px;
            color: #999;
          }
        }

        .el-button {
          margin: 16px 0;
          background-color: #67c23a;
          border-color: #67c23a;
          color: white;

          &:hover {
            background-color: #4caf50;
            border-color: #4caf50;
          }
        }
      }
    }

    .file-upload-section {
      margin-bottom: 20px;

      .uploaded-file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        border: 1px solid #dcdfe6;
        border-radius: 20px;
        background-color: #fbfbfb;
        margin-bottom: 20px;

        span {
          color: #333;
          font-weight: 500;
        }

        button {
          background-color: rgba(0, 0, 0, 0.1);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;

          &:hover {
            background-color: #d9534f;
          }
        }
      }
    }

    .question-area {
      border: 1px solid #dcdfe6;
      border-radius: 20px;
      background-color: #fbfbfb;
      margin-bottom: 20px;

      .question-config {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        p {
          color: rgba(0, 0, 0, 0.85);
          text-align: center;
          leading-trim: both;
          text-edge: cap;
          font-family: Roboto;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        .el-switch {
          margin-left: 10px;
        }
      }

      .question-types {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        p {
          color: rgba(0, 0, 0, 0.85);
          text-align: center;
          leading-trim: both;
          text-edge: cap;
          font-family: Roboto;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        .type-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          width: 70%;
          .el-button {
            padding: 10px;
            font-size: 18px;
            font-weight: 500;
            border-radius: 10px;
            margin: 0px;
            cursor: pointer;

            &.is-disabled {
              color: #606266;
            }

            &.success {
              background-color: rgba(28, 171, 54, 0.1);
              border: 1px solid #67c23a;
              color: #1cab36;

              &:hover {
                background-color: rgba(28, 171, 54, 0.1);
                border: 1px solid #67c23a;
              }
            }

            &.default {
              background-color: #f0f0f0;
              border: 1px solid rgba(0, 0, 0, 0.1);
              background: rgba(255, 255, 255, 0.1);
            }
          }
        }
      }
    }

    .loading-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100px;

      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-top: 4px solid #1cab36;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }

      p {
        margin-top: 10px;
        color: #333;
        font-weight: 500;
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
